import firebase from '../../plugins/firebase'
import { FIREBASE_ORDER_PLATFORM_TYPE, FIREBASE_ORDER_STATUS, FIREBASE_POS_ORDER_REF, FIREBASE_POS_QUEUE_REF } from '../../helpers/enum'
import { getDefaultBinLocationId, getNotifyPath, getOrderPath, getQueuePath, getStockPath } from '../../helpers'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import { getMasterDataText } from '@/helpers'

const getNewNotifies = (oldList, newList) => {
  const array1 = oldList.map((item) => item.notify_id)
  const array2 = newList.map((item) => item.notify_id)

  // Combine unique values from both arrays
  const uniqueValues = array1
    .filter(value => !array2.includes(value)) // Values in array1 but not in array2
    .concat(array2.filter(value => !array1.includes(value))) // Values in array2 but not in array1

  const results = uniqueValues.map((notifyId) => {
    const notify = newList.find((notifyItem) => notifyItem.notify_id === notifyId)
    return {
      ...notify,
    }
  })

  return results
}

export default {
  data() {
    return {
      firebaseOrderRef: null,
      firebaseOrderListener: null,
      firebaseQueueRef: null,
      firebaseQueueListener: null,
      firebaseNotifyRef: null,
      firebaseNotifyListener: null,
      firebaseStockRef: null,
      firebaseStockListener: null,

      startAt: Date.now(),
    }
  },

  computed: {
    ...mapGetters({
      posOrders: 'getPosOrders',
      getProductInfoById: 'getProductInfoById',
      getSkuInfoById: 'getSkuInfoById',
      isAssignedSkuToStock: 'isAssignedSkuToStock',
      shopInfo: 'getShopInfo',
      posSettings: 'getPosSetting',
      notifications: 'getNotifications',
      isQueueNumberExist: 'isQueueNumberExist',
      isSelectedCustomerByQueue: 'isSelectedCustomerByQueue',
      discounts: 'getDiscounts',
      taxes: 'getTaxes',
      customers: 'getCustomers',
      getPosQueueById: 'getPosQueueById',
      posProducts: 'getPosProducts',
    }),
    use_customer () {
      return this.posSettings.customer.is_active
    },
    refName () {
      return getMasterDataText(this.posSettings.table.ref_name, this.$t)
    },
    isActivePlaySound () {
      return this.posSettings.menu_online.play_alert_sound.is_active
    },
  },

  methods: {
    ...mapActions([
      'addPosOrder',
      'addPosQueueWith',
      'setNotifications',
      'setPosSelectedQueue',
      'updateNotify',
      'updatePosQueueCustomerId',
      'updatePosProductsStocks',
    ]),
    initFirebase() {
      const isActive_menuOnline = this.posSettings.menu_online.is_active
      if (isActive_menuOnline) {
        this.subscribeQueue()
        this.subscribeOrder()
        this.subscribeNotify()
      }
      this.subscribeStock()
    },
    subscribeQueue() {
      const shopId = this.shopInfo.shop_id
      const branchId = this.posSession.branch_id
      const psId = this.$route.query.id
      const path = getQueuePath(shopId, branchId, psId)
      this.firebaseQueueRef = firebase.database().ref(path)
      this.firebaseQueueListener = this.firebaseQueueRef.on('value', (snapshot) => {
        // console.log('subscribeQueue', snapshot.val())
        if (snapshot.val()) {
          const data = snapshot.val()
          const queues = Object.values(data)
          this.syncQueues(queues)
        }
      })
    },
    unsubscribeQueue() {
      this.firebaseQueueRef.off('value', this.firebaseQueueListener)
    },
    subscribeOrder() {
      const shopId = this.shopInfo.shop_id
      const branchId = this.posSession.branch_id
      const psId = this.$route.query.id
      const path = getOrderPath(shopId, branchId, psId)
      this.firebaseOrderRef = firebase.database().ref(path)
      this.firebaseOrderListener = this.firebaseOrderRef.on('value', (snapshot) => {
        // console.log('subscribeOrder', snapshot.val())
        if (snapshot.val()) {
          const data = snapshot.val()
          const orders = Object.values(data).reduce((acc, cur) => {
            acc = [
              ...acc,
              ...Object.values(cur),
            ]
            return acc
          }, [])
          // console.log('orders', orders)
          this.syncOrders(orders)
        }
      })
    },
    unsubscribeOrder() {
      this.firebaseOrderRef.off('value', this.firebaseOrderListener)
    },
    subscribeNotify() {
      const shopId = this.shopInfo.shop_id
      const branchId = this.posSession.branch_id
      const psId = this.$route.query.id
      const path = getNotifyPath(shopId, branchId, psId)
      this.firebaseNotifyRef = firebase.database().ref(path)
      this.firebaseNotifyListener = this.firebaseNotifyRef.on('value', (snapshot) => {
        // console.log('subscribeNotify', snapshot.val())
        if (snapshot.val()) {
          const data = snapshot.val()
          const notifies = Object.values(data).reduce((acc, cur) => {
            acc = [
              ...acc,
              ...Object.values(cur),
            ]
            return acc
          }, [])
          // console.log('notifies', notifies)
          // fixed: "v-click-outside" will trigger without setTimeout
          setTimeout(() => {
            const diffInMs = Date.now() - this.startAt
            if (diffInMs > 2000) {
              const newNotifies = getNewNotifies(this.notifications, notifies)
              if (newNotifies.length > 0 && this.isActivePlaySound) {
                this.playAudioNitify()
              }
              newNotifies.forEach((notify) => {
                this.notify(this.$vs, {
                  title: `${this.$t(`notification_code.${notify.code}`)} - ${this.$t(`platform_code.${notify.platform}`)}`,
                  text: (() => {
                    let str = ''
                    if (notify.table_number) {
                      str += this.$t('apps.pos.message.tablenumber', { ref_name: this.refName, number: notify.table_number })
                    }
                    if (notify.queue_number && !['', 'unknown'].includes(notify.queue_number)) {
                      str += ' ' + this.$t('apps.pos.message.queuenumber', { number: notify.queue_number })
                    }
                    if (notify.metadata.order) {
                      str += ' - ' + `${notify.metadata.order.item} x${notify.metadata.order.quantity}`
                    }
                    return str
                  })(),
                  color: 'primary',
                  icon: 'notifications',
                  position: 'bottom-left',
                  time: 1000 * 10,
                  click: () => {
                    const isQueueNumberExist = this.isQueueNumberExist(notify.queue_number)
                    if (isQueueNumberExist) {
                      this.setPosSelectedQueue(notify.queue_number)
                    }

                    this.updateNotify({
                      queueNumber: notify.queue_number,
                      notifyId: notify.notify_id,
                      payload: {
                        is_read: true,
                      },
                    })
                  },
                })
              })
            }

            this.syncNotifies(notifies)
          }, 10)
        }
      })
    },
    unsubscribeNotify() {
      this.firebaseNotifyRef.off('value', this.firebaseNotifyListener)
      this.setNotifications([])
    },
    subscribeStock() {
      const shopId = this.shopInfo.shop_id
      const path = getStockPath(shopId)
      this.firebaseStockRef = firebase.database().ref(path)
      this.firebaseStockListener = this.firebaseStockRef.on('value', (snapshot) => {
        // console.log('subscribeQueue', snapshot.val())
        if (snapshot.val()) {
          const data = snapshot.val()
          const stocks = Object.values(data)
          this.syncStocks(stocks)
        }
      })
    },
    unsubscribeStock() {
      this.firebaseStockRef.off('value', this.firebaseStockListener)
    },
    async syncOrders(orders) {
      for (const order of orders) {
        const isOrderExistInPos = this.posOrders.find((item) => item.order_id === order.order_id)
        const isOrderApproved = order.status === FIREBASE_ORDER_STATUS.APPROVED
        if (!isOrderExistInPos && isOrderApproved) {
          const branchAssignWhId = this.$store.state.posBranch.branch.whId
          const skuInfo = this.getSkuInfoById(order.sku_id)
          if (skuInfo) {
            const productInfo = this.getProductInfoById(skuInfo.product_id)
            const stocks = skuInfo.stocks
            const stockId = this.isAssignedSkuToStock(branchAssignWhId, order.sku_id) && branchAssignWhId ? stocks[0].stock_id : null
            const warehouseId = this.isAssignedSkuToStock(branchAssignWhId, order.sku_id) && branchAssignWhId ? stocks[0].warehouse_id : null
            const binLocationId = this.isAssignedSkuToStock(branchAssignWhId, order.sku_id) && branchAssignWhId ? getDefaultBinLocationId(stocks[0].stock_locations) : null
            const newOrder = {
              order_id: order.order_id,
              customer_id: order.customer_id,
              queue_number: order.queue_number,
              table_number: order.table_number,
              sku_id: order.sku_id,
              item: order.item,
              price: skuInfo.price,
              cost: skuInfo.cost,
              quantity: order.quantity,
              attributes: order.attributes || [],
              modifiers: (order.modifiers || []).map((modifierRef) => {
                return {
                  ...modifierRef,
                  options: modifierRef.options.map((optionRef) => {
                    return {
                      ...optionRef,
                      modifieroption_id: optionRef.option_id,
                      option: optionRef.name,
                    }
                  }),
                }
              }),
              discounts: (order.discounts || []).map((discountRef) => {
                const masterDiscount = this.discounts.find((masterDiscount) => masterDiscount.discount_id === discountRef.discount_id)
                return {
                  ...discountRef,
                  ...masterDiscount,
                }
              }),
              taxes: (order.taxes || []).map((taxRef) => {
                const masterTax = this.taxes.find((masterTax) => masterTax.tax_id === taxRef.tax_id)
                return {
                  ...taxRef,
                  ...masterTax,
                }
              }),
              stock_id: stockId,
              warehouse_id: warehouseId,
              bin_location_id: binLocationId,
              unit: productInfo.unit,
            }
            if (order.note) {
              newOrder['note'] = order.note
            }
            this.addPosOrder(newOrder)

            /**
             * auto select customer id
             */
            if (order.customer_id && this.use_customer) {
              const isCustomerExist = this.customers.find((cus) => cus.customer_id === order.customer_id)
              if (!isCustomerExist) {
                await this.$store.dispatch('getCustomers')
                this.showFinish(this.$Progress)
              }

              let customerId = null
              if (this.isSelectedCustomerByQueue(Number(order.queue_number))) {
                const queue = this.getPosQueueById(Number(order.queue_number))
                if (queue) {
                  customerId = queue.customer_id
                }
              } else {
                customerId = order.customer_id
              }

              if (customerId) {
                this.updatePosQueueCustomerId({
                  queue_number: Number(order.queue_number),
                  customer_id: customerId,
                })
              }
            }
          }
        }
      }
    },
    syncQueues(queues) {
      for (const queue of queues) {
        // sync only queue that come from menu_online's app
        if (queue.platform === FIREBASE_ORDER_PLATFORM_TYPE.MENU_ONLINE && queue.is_paid === false) {
          this.addPosQueueWith({
            qrcode_id: queue.qrcode_id,
            qrcode_type: queue.qrcode_type,
            queue_number: queue.queue_number,
            table_number: queue.table_number ? queue.table_number : null,
            dining_name: 'menu_online',
            expired_at: queue.expired_at,
            expire_time_mins: queue.expire_time_mins,
          })
        }
      }
    },
    syncNotifies(notifies) {
      this.setNotifications(notifies)
    },
    syncStocks(stocks) {
      this.updatePosProductsStocks(stocks)
    },
    playAudioNitify() {
      const audio = this.$refs.audioPlayer
      if (audio) {
        audio.pause()
        audio.currentTime = 0
        audio.volume = 1
        audio.play().catch((err) => {})
      }
    },
  },

  destroyed () {
    // clear firebase realtime database
    if (this.firebaseQueueListener) {
      this.unsubscribeQueue()
    }
    if (this.firebaseOrderListener) {
      this.unsubscribeOrder()
    }
    if (this.firebaseNotifyListener) {
      this.unsubscribeNotify()
    }
    if (this.firebaseStockListener) {
      this.unsubscribeStock()
    }
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/firebase.js